
var GapLess = {};
import genaration from '../../utils/classname';
export var gapClass = genaration(GapLess, 'gap');